// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"eb09864b","929":"e6107513","934":"a5507998"}[chunkId] + ".chunk.js";
};